import {FC} from 'react'
import {DotLoading, Space} from 'antd-mobile'
import css from './index.module.less';

export const PageLoading: FC = () => {
  return (
    <Space className={css.PageLoading} align={'center'} justify={'center'}><DotLoading color={'primary'} /></Space>
  )
}

